module.exports = __webpack_public_path__ + "img/foot_img1.1158da96.png";